import { SystemDescriptions } from "src/common/descriptions";
import { formatToCurrency, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CONTRACT_PAYMENTS

export enum ColumnsKeys {
    NO = 'key',
    DATETIME = 'datetime',
    SERVICE_CONTRACT_DEBIT_ID = 'serviceContractDebitId',
    AMOUNT = 'amount',
    CASH = 'cash',
    TRANSACTION = 'transaction',
    DISSCOUNT = 'disscount',
    COMMENT = 'comment',
    ACTIONS = 'ACTIONS',
    CUSTOMER = 'customer',
    DESCRIPTION = 'description',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DATETIME,
        dataIndex: ColumnsKeys.DATETIME,
        key: ColumnsKeys.DATETIME,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToDisplayDatetime(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.CUSTOMER,
        dataIndex: ColumnsKeys.CUSTOMER,
        key: ColumnsKeys.CUSTOMER,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.AMOUNT,
        key: ColumnsKeys.AMOUNT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.CASH,
        dataIndex: ColumnsKeys.CASH,
        key: ColumnsKeys.CASH,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.TRANSACTION,
        dataIndex: ColumnsKeys.TRANSACTION,
        key: ColumnsKeys.TRANSACTION,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
    {
        title: descriptions.TABLE_COLUMNS.DISSCOUNT,
        dataIndex: ColumnsKeys.DISSCOUNT,
        key: ColumnsKeys.DISSCOUNT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value),
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.AMOUNT]: SummaryType.SUM,
    [ColumnsKeys.CASH]: SummaryType.SUM,
    [ColumnsKeys.TRANSACTION]: SummaryType.SUM,
    [ColumnsKeys.DISSCOUNT]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}